import React from "react";

class TypesButtons extends React.PureComponent {
  render() {
    const {
      types,
      clientWidth,
      typesOpen,
      hideBtn,
      onClickTypesOpen,
      onTypesBtnClick
    } = this.props;

    return (
      <React.Fragment>
        {!clientWidth ? (
          <div
            className="afisha-search_selection__types"
            style={{ width: "177px" }}
            onClick={() => !clientWidth && onClickTypesOpen()}
          >
            <div style={typesOpen ? { position: "relative" } : null}>
              <div
                style={typesOpen ? Container : null}
                className="afisha_btn-box"
              >
                <button
                  className="afisha_btn"
                  style={
                    typesOpen
                      ? { marginTop: "0", marginRight: "0", width: "177px" }
                      : { marginTop: "10px", width: "177px" }
                  }
                >
                  Выберите читальню
                  <svg
                    style={
                      typesOpen
                        ? {
                            ...TypesIcon,
                            transform: "rotate(180deg)"
                          }
                        : TypesIcon
                    }
                    width="10"
                    height="5"
                    viewBox="0 0 10 5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 0L5 5L10 0H0Z"
                      fill="#2B2B2B"
                    />
                  </svg>
                </button>
                <div
                  className={hideBtn}
                  style={
                    !hideBtn
                      ? {
                          display: "flex",
                          flexFlow: "column",
                          alignItems: "center"
                        }
                      : null
                  }
                >
                  {types &&
                    Object.keys(types).map((key, i) => (
                      <Buttons
                        style={{ minHeight: "30px" }}
                        key={i}
                        index={i}
                        value={types[key]}
                        onTypesBtnClick={onTypesBtnClick}
                        classObject={`afisha_btn${types[key].classObject}`}
                      />
                    ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="afisha_btn-box-hidden">
            {types &&
              Object.keys(types).map((key, i) => (
                <Buttons
                  key={i}
                  index={i}
                  value={types[key]}
                  onTypesBtnClick={onTypesBtnClick}
                  classObject={`afisha_btn${types[key].classObject}`}
                />
              ))}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default TypesButtons;

const Buttons = ({ index, value, onTypesBtnClick, classObject }) => (
  <button
    onClick={() => onTypesBtnClick(index, value.id)}
    className={classObject}
  >
    {value.text}
  </button>
);

const TypesIcon = {
  marginLeft: "5px",
  marginBottom: "1px",
  transform: "rotate(0)"
};

const Container = {
  display: "flex",
  flexFlow: "column",
  padding: "10px",
  background: "#ffffff",
  boxShadow: "0px 0px 10px #e9e9f0",
  borderRadius: "5px",
  alignItems: "center",
  zIndex: "1",
  right: "-17px",
  position: "absolute",
  marginRight: "6px"
};



// WEBPACK FOOTER //
// ./src/components/Events/TypesButtons.js